import { createFileRoute } from '@tanstack/react-router';

import { client } from '@@api/client';
import { handleLoaderError } from '@@router/handleLoaderError';

import { EditKickwordForm } from './-components/KickwordForm';

export const Route = createFileRoute('/_authenticated/kickwords/$id')({
    context: ({ params }) => ({
        kickwordQuery: client.metadata.kickwords.get.queryOptions(
            { params: { id: Number(params.id) } },
            { refetchOnWindowFocus: false },
        ),
    }),
    loader: ({ context }) =>
        context.queryClient
            .query({ ...context.kickwordQuery, staleTime: 'static' })
            .catch(handleLoaderError),
    component: EditKickwordForm,
});
